import { log } from '../../logger/logger.js';
const mark = (label) => {
    window.performance?.mark?.(label);
    if (process.env.NODE_ENV !== "test") {
        log("cmp", "[event]", label);
    }
};
export { mark };
